/*
TODO
Update the failed login to display a proper error
*/

import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import auth from './auth';
// import AppStore from '../Resources/app-store.png';
// import PlayStore from '../Resources/play-store.png';
import BlueLogo from '../Resources/logo-blue.png';

export const AppDownload = props => {
  const [notLoading] = useState(true);
  var newUser = true;

  React.useEffect(() =>{
    if('parentIFrame' in window) {
      window.parentIFrame.scrollTo(0, 0);
    }
  }, []);

  const redirectHome = () => {
    props.history.push('/home')
  }
  var employeeCode = props.location.search;
  if(employeeCode){
    employeeCode = employeeCode.split('=').pop();
  }

  //Gets User IP Address
  const getIP = () => {
    return new Promise(function(resolve, reject){
      fetch('https://api.ipify.org/?format=json')
      .then(function(response){
        return response.json();
      })
      .then(function(data){
        resolve(data);
      });
    });
  }

  //Records the click, logs the device info and sets the newUser to false.
  const logStoreClick = (type) => {
    if (!authenticated && newUser) {
      newUser = false;
      getIP()
      .then(function(ip){
        var body = {
          'ip': ip.ip,
          'userAgent': navigator.userAgent,
          'type': type
        };
        fetch(localStorage.getItem('server') + 'app/' + employeeCode, {
          method: 'PUT',
          body: JSON.stringify(body)
        });
      });
    }
  }

  //Checks for device uniqueID
  var uniqueID;
  if(window.localStorage){
    uniqueID = localStorage.getItem('UID');
  }

  if(uniqueID){
    newUser = false;
  } else {
    newUser = true;
    var newUID = ((Date.now().toString(36) + Math.random().toString(36).substr(2, 5)) + Math.random(Date.now())).replace('.', '');
    localStorage.setItem('UID', newUID);
  }

  var authenticated = auth.authenticated;

  return (
    <div className="container">
      <div className="overlay" hidden={notLoading}>
        <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300} />
      </div>
      <div className="mini-form">
      {!authenticated ? <img className="logo-centered" src={BlueLogo} alt="Logo"/> : '' }
        <h2 className='text-center'><strong>Download the App!</strong></h2>
        <p className="text-center">Access your digital membership with our mobile app today!</p>
        <div className="row">
          <div className="col-sm-6 text-center text-sm-left" onClick={ev=>logStoreClick('app')}>
            <a href="https://apps.apple.com/us/app/bankstown-sports/id1530485834" target="_blank" rel="noreferrer"><img src={'https://customers.bankstownsports.com/static/media/app-store.a4ab3810.png'} alt="App Store" /></a>
          </div>
          <div className="col-sm-6 text-center text-sm-right" onClick={ev=>logStoreClick('app')}>
            <a href="https://play.google.com/store/apps/details?id=com.bankstown.sportscentredroid&hl=en_AU&gl=US" target="_blank" rel="noreferrer"><img src={'https://customers.bankstownsports.com/static/media/play-store.18c0b5ef.png'} alt="Play Store" /></a>
          </div>
        </div>
        {authenticated ?
          <button className="form-btn btn btn-primary float-left formButton" onClick={redirectHome}>Back</button>
          :
          <div>
            <h3 className="text-center">OR</h3>
            <a href="https://customers.bankstownsports.com/" target="_blank" rel="noreferrer"><button className="form-btn btn btn-primary" onClick={ev=>logStoreClick('signup')}>Become a member</button></a>
          </div>
        }
      </div>
    </div>
  )
}